import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboTurnoComponent } from './combo-turno.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboTurnoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboTurnoComponent]
})
export class ComboTurnoModule { }
